import { isConsolidatedDashboard } from "dashboard-utils";
import { appUrls } from "./urls";

export const MENU_ITEM_IDENTIFIERS = {
    HELP: 'HELP',
    ANALYTICS: 'ANALYTICS',
    USER_MENU: 'USER_MENU',
    ONBOARDING_PROFILE: 'ONBOARDING_PROFILE',
    DASHBOARD_SETTINGS: 'DASHBOARD_SETTINGS',
    USER_LOGOUT: 'USER_LOGOUT',
    SWITCH_TO_BIZ_DASHBOARD: 'SWITCH_TO_BIZ_DASHBOARD',
    BUSINESS_DASHBOARD: 'BUSINESS_DASHBOARD',
    SF_CHAT_BUTTON: 'SF_CHAT_BUTTON',
    SWITCH_TO_DIFF_MID: 'SWITCH_TO_DIFF_MID'
  }
  
  export const MENUS_ITEMS = {
    [MENU_ITEM_IDENTIFIERS.SWITCH_TO_DIFF_MID]: {
      label: 'Switch MID',
      iconProps: { type: 'refresh', size: '16px', className: 'twside-text-primary-500' },
      path: `${appUrls.ONBOARDING_HOST}/app/account/team-accounts`,
      identifier: MENU_ITEM_IDENTIFIERS.SWITCH_TO_DIFF_MID,
    },
    [MENU_ITEM_IDENTIFIERS.HELP]: {
      label: 'Help',
      iconProps: { type: 'help', size: '18px', className: 'twside-text-primary-500'  },
      path: process.env.CARE_HOST,
      identifier: MENU_ITEM_IDENTIFIERS.HELP,
    },
    [MENU_ITEM_IDENTIFIERS.ANALYTICS]: {
      label: 'Analytics',
      iconProps: { type: 'report', size: '18px', className: 'twside-text-primary-500' },
      path: '/business/lookup',
      identifier: MENU_ITEM_IDENTIFIERS.ANALYTICS,
    },
    [MENU_ITEM_IDENTIFIERS.BUSINESS_DASHBOARD]: {
      label: 'Dashboard',
      iconProps: { type: 'summary', size: '18px', className: 'twside-text-primary-500'  },
      path: '/business',
      identifier: MENU_ITEM_IDENTIFIERS.BUSINESS_DASHBOARD,
    },
    [MENU_ITEM_IDENTIFIERS.USER_MENU]: {
      label: 'Username',
      iconProps: { type: 'profile', size: '18px', className: 'twside-text-primary-500'  },
      path: '#',
      identifier: MENU_ITEM_IDENTIFIERS.USER_MENU,
    },
    [MENU_ITEM_IDENTIFIERS.ONBOARDING_PROFILE]: {
      label: 'Profile',
      iconProps: { type: 'user', size: '16px', className: '!twside-text-primary-500'  },
      path: `${process.env.ONBOARDING_HOST}/app/onboarding/settings`,
      identifier: MENU_ITEM_IDENTIFIERS.ONBOARDING_PROFILE,
      disabled: isConsolidatedDashboard
    },
    
    [MENU_ITEM_IDENTIFIERS.SF_CHAT_BUTTON]: {
      label: 'Chat to expert',
      iconProps: { type: 'product-card_document-text', size: '16px', className: 'twside-text-primary-500' },
      identifier: MENU_ITEM_IDENTIFIERS.SF_CHAT_BUTTON,
    },
    [MENU_ITEM_IDENTIFIERS.DASHBOARD_SETTINGS]: {
      label: 'Settings',
      iconProps: { type: 'gear', size: '16px', className: 'twside-text-primary-500'  },
      path: `/business/settings`,
      identifier: MENU_ITEM_IDENTIFIERS.DASHBOARD_SETTINGS,
      disabled: isConsolidatedDashboard
    },
    [MENU_ITEM_IDENTIFIERS.SWITCH_TO_BIZ_DASHBOARD]: {
      label: 'Switch to PayUBiz',
      iconProps: { type: 'up-down', size: '16px', className: 'twside-text-primary-500'  },
      identifier: MENU_ITEM_IDENTIFIERS.SWITCH_TO_BIZ_DASHBOARD,
    },
    [MENU_ITEM_IDENTIFIERS.USER_LOGOUT]: {
      label: 'Sign Out',
      iconProps: { type: 'logout', size: '16px', className: 'twside-text-primary-500'  },
      path: `${process.env.ONBOARDING_HOST}/account/service_logout?redirect_to=${window.location.href}`,
      identifier: MENU_ITEM_IDENTIFIERS.USER_LOGOUT,
    },
  }
  
  export const PAYU_ICON_PROPS = {
    DARK: { type: 'payu-logo', size: '32px', color: 'dark', color: '#3B3F46' }
  }
  
  export const appSourceQueryParamKey = 'appSource',
    nativeAppAuthTokenKey = 'authToken',
    appSourceQueryParamValues = { ANDROID_APP: 'AndroidApp', IOS_APP: 'iOSApp' },
    COOKIES_KEYS = {
      AUTH_TOKEN: 'merchantAccessToken',
      MERCHANT_MID: 'mid',
      PRODUCT: 'product',
      DASHBOARD_PREFERENCE: 'dashboardPreference',
      CHAT_BOT: 'chatbot',
      MERCHANT_ACCOUNT_UUID: 'merchant_account_uuid',
      PRODUCT_ACCOUNT_UUID: 'product_account_uuid',
      TEST_AUTH_TOKEN: 'testAccessToken',
      TEST_MERCHANT_MID: 'test_mid',
      TEST_MERCHANT_ACCOUNT_UUID: 'test_merchant_account_uuid',
      TEST_PRODUCT_ACCOUNT_UUID: 'test_product_account_uuid',
    };
  
  export const MOBILE_VIEW_PROPS = {
    TOPBAR_VISIBLE: true
  }
  
  export const ENUM_APP_SOURCE = {
    ANDROID: 'AndroidApp',
    WEB: 'Web',
    iOS: 'iOSApp',
  };
  
  export const APP_CALLBACK_ACTION = {
    LOGOUT: 'Logout',
    HARDWARE_BACK_PRESSED: 'BackPressed',
    PRIORITY_SETTLEMENTS_ACTIVATION_COMPLETED: 'PrioritySettlementsActivationCompleted',
  };
  
  export const postMessageToNativeApp = (payload) => {
    try {
      if (typeof PayUonboarding != "undefined") {
        PayUonboarding.callback(JSON.stringify(payload));
        console.log("Posting back to Android App: \n", payload);
      }
      else if (typeof window.webkit.messageHandlers.payuOnboardingCallback.postMessage == 'function') {
        window.webkit.messageHandlers.payuOnboardingCallback.postMessage(payload);
        console.log("Posting back to iOS App: \n", payload);
      }
    } catch (err) {
      console.log('Error in posting message to Native App: \n', err);
    };
  };
  
  export const appHardwareBackEventListener = () => {
    try {
      document.addEventListener(
        "backbutton",
        () => postMessageToNativeApp({ action: APP_CALLBACK_ACTION.HARDWARE_BACK_PRESSED }),
        false
      );
    } catch (err) {
      console.log('Error in appHardwareBackEventListener: ', err);
    }
  };
  